import { push } from 'connected-react-router'
import { connect } from 'react-redux'
import {
  branch,
  compose,
  lifecycle,
  renderComponent,
  withHandlers,
  withState,
} from 'recompose'
import { bindActionCreators } from 'redux'

import config from 'config'
import * as actions from 'modules/org/actions'
import { updateUserProperties } from 'modules/user/actions'
import * as UserSelectors from 'modules/user/selectors'
import { page, track } from 'utils/trackingUtils'

import { AEExtensionStep, ExtensionStep } from './component'

const WEBSTORE_LINK =
  'https://chrome.google.com/webstore/detail/obpicmhmbfddhkcbiapfeginbafnjmmm'

const mapStateToProps = (state) => {
  return {
    isRepInvitedFlow: UserSelectors.isRepInvitedFlow(state),
    isSSOProvisionedFlow: UserSelectors.isSSOProvisionedFlow(state),
    userId: UserSelectors.getUserId(state),
  }
}

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      updateOrgProperties: actions.updateOrgProperties,
      updateUserProperties,
      push,
    },
    dispatch
  ),
})

const finishExtensionMethodStep = (props, action, method) => {
  track(action, {
    context: props.isCalendarSeat
      ? 'calendaring-seat-onboarding'
      : props.isRepInvitedFlow
      ? 'rep-onboarding'
      : 'sales-onboarding',
    isSSO: props.isSSOProvisionedFlow,
    method,
  })
  props.setCompleting(true)
  if (props.isSSOProvisionedFlow) {
    props.actions.updateUserProperties({
      properties: {
        IS_JIT_PROVISIONED_USER: false,
      },
    })
  }

  if (props.isCalendarSeat) {
    props.actions.push('/setup/calendaring/hooray')
  } else {
    track('Onboarding Completed', {
      context: props.isRepInvitedFlow ? 'rep-onboarding' : 'sales-onboarding',
      isSSO: props.isSSOProvisionedFlow,
      shownExtension: true,
    })
    props.isRepInvitedFlow
      ? window.location.replace(`${config.CUSTOMER_WEB_URL}/home`)
      : props.actions.updateOrgProperties({
          properties: { signUpDone: true, onboardedDriftForSales: true },
          redirect: true,
        })
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('installed', 'setInstalled', false),
  withState('completing', 'setCompleting', false),
  lifecycle({
    componentDidMount() {
      page('Onboarding Extension Install', {
        context: this.props.isCalendarSeat
          ? 'calendaring-seat-onboarding'
          : this.props.isRepInvitedFlow
          ? 'rep-onboarding'
          : 'sales-onboarding',
      })
    },
  }),
  withHandlers({
    onInstallClick: (props) => () => {
      track('Onboarding Extension Method Chosen', {
        context: props.isCalendarSeat
          ? 'calendaring-seat-onboarding'
          : props.isRepInvitedFlow
          ? 'rep-onboarding'
          : 'sales-onboarding',
        method: 'chrome-browser',
      })

      window.open(
        WEBSTORE_LINK,
        '_blank',
        'location=0,status=0,width=1080,height=680'
      )
      props.setInstalled(true)
    },
    onCompleteClick: (props) => () => {
      finishExtensionMethodStep(
        props,
        'Onboarding Extension Install Completed',
        'chrome-browser'
      )
    },
    onSkipClick: (props) => () => {
      finishExtensionMethodStep(
        props,
        'Onboarding Extension Install Completed',
        'skipped'
      )
    },
  }),
  branch((props) => props.isCalendarSeat, renderComponent(AEExtensionStep))
)(ExtensionStep)
